var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPassporticon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9974 2.14789H3.9974C3.64377 2.14789 3.30464 2.28836 3.05459 2.53841C2.80454 2.78846 2.66406 3.1276 2.66406 3.48122V14.1479C2.66406 14.5015 2.80454 14.8406 3.05459 15.0907C3.30464 15.3407 3.64377 15.4812 3.9974 15.4812H11.9974C12.351 15.4812 12.6902 15.3407 12.9402 15.0907C13.1903 14.8406 13.3307 14.5015 13.3307 14.1479V5.48122L9.9974 2.14789Z",
    stroke: "#3263E5",
    strokeWidth: 0.951249,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33203 2.14789V4.81455C9.33203 5.16818 9.47251 5.50732 9.72256 5.75736C9.9726 6.00741 10.3117 6.14789 10.6654 6.14789H13.332",
    stroke: "#3263E5",
    strokeWidth: 0.951249,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66536 6.81586H5.33203",
    stroke: "#3263E5",
    strokeWidth: 0.951249,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6654 9.48383H5.33203",
    stroke: "#3263E5",
    strokeWidth: 0.951249,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6654 12.1479H5.33203",
    stroke: "#3263E5",
    strokeWidth: 0.951249,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassporticon);
export default __webpack_public_path__ + "static/media/passporticon.a4159b60bd597ada632bc1f00a460a08.svg";
export { ForwardRef as ReactComponent };